module.exports = __webpack_public_path__ + "img/8705154.jpg";